import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_3 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column","width":"auto","padding":"20px"}
}
const _hoisted_4 = { class: "descriptions-item" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("待审核")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("已通过")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("未知状态")
const _hoisted_9 = {
  key: 0,
  class: "descriptions-item"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"700"} }, "权利证明", -1)
const _hoisted_11 = { style: {"display":"flex","flex-direction":"row","flex-wrap":"wrap","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_page_header = _resolveComponent("page-header")!
  const _component_bimgx_image = _resolveComponent("bimgx-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_page_header, { title: "举报详情" }, _createSlots({ _: 2 }, [
      (_ctx.imgReport && _ctx.imgReport.status == 'AWAIT_REVIEW')
        ? {
            name: "right",
            fn: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onReview('APPROVE'))),
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onReview('DISAPPROVE'))),
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ])
          }
        : undefined
    ]), 1024),
    (_ctx.imgReport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_bimgx_image, {
            src: _ctx.imgReport.img.url,
            style: {"width":"200px","height":"200px","object-fit":"contain"}
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.imgReport.status == 'AWAIT_REVIEW')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "info"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : (_ctx.imgReport.status == 'APPROVE')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : (_ctx.imgReport.status == 'DISAPPROVE')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_tag, {
                      key: 3,
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }))
          ]),
          _createVNode(_component_el_descriptions, {
            title: "表情信息",
            class: "descriptions-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "hid：" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.imgReport.img.hid), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "上传时间：" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(new Date(_ctx.imgReport.img.createdAt).toLocaleString("zh-CN", {
                    hour12: false
                })), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "上传用户hid：" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.imgReport.img.user?.hid), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "上传用户名：" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.imgReport.img.user?.nickname), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions, {
            title: "举报信息",
            class: "descriptions-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "hid：" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.imgReport.hid), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "举报时间：" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(new Date(_ctx.imgReport.createdAt).toLocaleString("zh-CN", {
                    hour12: false
                })), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "举报类型：" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.imgReport.type), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "举报说明：" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.imgReport.desc), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.imgReport.extendInfo)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.imgReport.type == 'COPYRIGHT')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgReport.extendInfo.rightFileList, (img) => {
                          return (_openBlock(), _createBlock(_component_bimgx_image, {
                            key: img.hid,
                            src: img.url,
                            canNewTabView: true,
                            style: {"width":"200px","height":"200px","object-fit":"contain"}
                          }, null, 8, ["src"]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}